<ng-container *ngIf="selected == 'D'; else other">
  <div class="container grid">
    <div class="row p-xl-4 my-4">
      <div class="col-11 d-flex align-items-center">
        <h2 class="blue-50 text-center w-700">Prenota una demo di Easycode</h2>
      </div>
      <div class="col-1 d-flex justify-content-end align-items-start">
        <img
          class="close-btn pointer"
          alt="close"
         
          src="assets/img/close-menu.png"
          (click)="activeModal.close()"
        />
      </div>
    </div>
    <div class="modal-container course-desc">
      Selezionando “Prenota una demo”, verrai reindirizzato al calendario delle
      disponibilità di orari per fare un tour della piattaforma Easycode con
      noi. Attraverso una breve chiacchierata con un membro del nostro team,
      potrai avere un assaggio delle potenzialità di Easycode. Prenota la tua
      demo oggi e inizia il tuo viaggio verso il futuro con Easycode 🤖”
      <a
      style="text-decoration: none; text-align: center;"
        class="btn-lightblue m-custom mt-4"
        href="https://calendly.com/demo-easycode"
        target="_blank"
      >
        <span class="button-txt">Prenota Demo</span>
      </a>
    </div>
  </div>
</ng-container>

<ng-template #other>
  <div class="container grid">
    <div class="row p-xl-4 my-4">
      <div class="col-2 col-xl-3"></div>
      <div class="col-8 col-xl-6 d-flex align-items-center">
        <h2 class="blue-50 text-center w-700">Iscriviti a Easycode</h2>
      </div>
      <div class="col-2 col-xl-3 d-flex justify-content-end align-items-start">
        <img
          class="close-btn pointer"
          alt="close"
         
          src="assets/img/close-menu.png"
          (click)="activeModal.close()"
        />
      </div>
    </div>
  </div>

  <div class="row m-0 p-xl-2 mb-5">
    <div class="row col-xl-10 m-auto p-0" style="display: inline-flex">
      <div
        class="col-6 card-h pointer"
        [ngClass]="selected == 'E' ? 'selected' : ''"
        (click)="toggle('E')"
      >
        <p class="blue-50 m-auto" [ngClass]="selected == 'E' ? 'bold' : ''">
          Educatori Digitali
        </p>
      </div>
      <div
        class="col-6 card-h pointer"
        [ngClass]="selected == 'S' ? 'selected' : ''"
        (click)="toggle('S')"
      >
        <p class="blue-50 m-auto" [ngClass]="selected == 'S' ? 'bold' : ''">
          Istituti Scolastici
        </p>
      </div>
    </div>
    <div class="row col-xl-10 m-auto form-container">
      <ng-container *ngIf="selected == 'E'">
        <app-form-educatore></app-form-educatore>
      </ng-container>
      <ng-container *ngIf="selected == 'S'">
        <app-form-scuola></app-form-scuola>
      </ng-container>
    </div>
  </div>
</ng-template>
